import { render, staticRenderFns } from "./feedbackEdit.vue?vue&type=template&id=126640ea"
import script from "./feedbackEdit.vue?vue&type=script&lang=js"
export * from "./feedbackEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports